import { render, staticRenderFns } from "./IQSidePanelAIMessage.vue?vue&type=template&id=4e9b273f&scoped=true"
import script from "./IQSidePanelAIMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./IQSidePanelAIMessage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQSidePanelAIMessage.vue?vue&type=style&index=0&id=4e9b273f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9b273f",
  null
  
)

export default component.exports